module.exports = __webpack_public_path__ + "static/media/new_view.141549e7.svg";